const sortDataByIdAndOrder = (arr) => {
  const comparator = (a, b) => {
    // both sort orders are null, so sort by id
    if (a.sortOrder == null && b.sortOrder == null) {
      // this item has a higher db ID than the other, which means it was created after other
      if (a.id > b.id) {
        return -1;
      } else {
        return 1;
      }
    } else if (a.sortOrder == null && b.sortOrder != null) {
      // sort order specified for other item, that takes precedence, this should go at the end
      return 1;
    } else if (a.sortOrder != null && b.sortOrder == null) {
      // sort order specified for this item, not the other, so this takes precedence
      return -1;
    } else {
      // now we know sort orders aren't null. lower sort order means higher in ranking
      if (a.sortOrder < b.sortOrder) {
        return -1;
      } else {
        return 1;
      }
    }
  };

  const copy = arr;

  copy.sort(function (a, b) {
    return comparator(a, b);
  });

  const data = [];
  let nullRankFlag = false;
  copy.map((element) => {
    if (element.sortOrder && !element.retired) {
      return (data[element.sortOrder - 1] = {
        ...element,
      });
    } else {
      nullRankFlag = true;
    }
  });

  if (nullRankFlag) {
    copy.reverse().map((element) => {
      if (!element.sortOrder && !element.retired) {
        return data.push({
          ...element,
        });
      }
    });
  }

  // console.log("printing sorted list");
  // console.dir(copy);
  return copy;
};

export default sortDataByIdAndOrder;
